import { __extends } from "tslib";
import { EventBase } from '@awayjs/core';
var RTTEvent = /** @class */ (function (_super) {
    __extends(RTTEvent, _super);
    function RTTEvent(type, rttManager) {
        var _this = _super.call(this, type) || this;
        _this._rttManager = rttManager;
        return _this;
    }
    Object.defineProperty(RTTEvent.prototype, "rttManager", {
        /**
         *
         */
        get: function () {
            return this._rttManager;
        },
        enumerable: false,
        configurable: true
    });
    /**
     *
     */
    RTTEvent.prototype.clone = function () {
        return new RTTEvent(this.type, this._rttManager);
    };
    /**
     *
     */
    RTTEvent.RESIZE = 'rttManagerResize';
    return RTTEvent;
}(EventBase));
export { RTTEvent };
